export const TEXTS = {
    HEADING: "Uh-oh! We could not find any matches",
    DESCRIPTION: "Remove some filters and try again",
    TERMS_AND_CONDITIONS: "Terms & conditions",
    PRIVACY_POLICY: "Privacy policy",
};

export const FLOATING_WIDGET_POSITIONS = {
    BOTTOM_WITH_CART: "160px",
    BOTTOM_WITHOUT_CART: "100px",
};
export const SCROLL_POSITION_WITHOUT_CATEGORY = 0.0; // in range of 0 to 1
export const SCROLL_POSITION_WITH_CATEGORY = 0.35; // in range of 0 to 1
export const SCROLL_POSITION_WITH_MULTIPLE_LINES = 0.43; // in range of 0 to 1

export const SCROLL_TIMEOUT = 100;
// Combined height of floating widget (150px) + sticky pills (64px) + buffer
export const SCROLL_OFFSET = 220;

export const ITEMS_FOR_SINGLE_LINE = 8;

export const MENU_CONTAINER_ID = "menu-container";
export const CATEGORY_HEADING_ID = "category-heading";
